import { render, staticRenderFns } from "./common-map.vue?vue&type=template&id=2ba13d13"
import script from "./common-map.vue?vue&type=script&lang=js"
export * from "./common-map.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports